/**
 * For some old templates in E1 the font family is wrapped with an extra "" or ''
 * This function removes these characters
 *
 * @param fontFamily The font family string
 * @returns The font family string without the extra characters
 */
export const parseFont = (fontFamily: string) => {
  if (!fontFamily) return '';

  // if the font is wrapped with ' or " remove these characters
  if (
    fontFamily[0] === "'" ||
    (fontFamily[0] === '"' && fontFamily[fontFamily.length - 1] === "'") ||
    fontFamily[fontFamily.length - 1] === '"'
  ) {
    fontFamily = fontFamily.substring(1, fontFamily.length - 1);
  }

  return fontFamily?.split(',')[0].trim() || '';
};
